import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoTitle, viewMenu, rakuMenu } from 'images'
import OrderDeliveryButton from './OrderDeliveryButton'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/jwtXW2Bc6tUEEYtcnIIt/locations/MvLV4OUJjaddWhfyWwXM'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100vw"
          bg="rgba(0,0,0,.8)"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          pt="10px"
          pb="20px"
        >
          <CFView column center>
            <CFView row center>
              <CFImage h="75px" src={logo} alt="Raku Sushi Logo" />
              <CFView mt="12px">
                {/* <CFLink href={rakuMenu} newTab>
                  <CFImage
                    h="60px"
                    src={viewMenu}
                    alt="Raku Sushi View Menu Button"
                  />
                </CFLink> */}
                <OrderDeliveryButton />
              </CFView>
            </CFView>
            <CFImage
              w="90vw"
              mt="10px"
              src={logoTitle}
              alt="Raku Sushi Logo Title"
            />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          row
          justifyStart
          h="70px"
          bg="transparent"
          zIndex={98}
          bg="rgba(0,0,0,.8)"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
        >
          <CFView
            row
            justifyBetween
            alignCenter
            w="100%"
            maxWidth="1400px"
            ph="30px"
          >
            <CFView row justifyStart mt="75px">
              <CFImage
                h="170px"
                mt="40px"
                src={logo}
                alt="Raku Sushi Logo"
                zIndex={98}
              />
              <CFImage
                h="26px"
                mt="55px"
                ml="10px"
                src={logoTitle}
                alt="Raku Sushi Logo Title"
              />
              {/* <CFSelect selector={dispatch.restaurant.getHasMultipleLocations}>
                <CFView mt="15px" zIndex={99}>
                  <LocationSelect />
                </CFView>
              </CFSelect> */}
            </CFView>
            {/* <CFView hover mt="12px">
              <CFLink href={rakuMenu} newTab>
                <CFImage
                  h="60px"
                  src={viewMenu}
                  alt="Raku Sushi View Menu Button"
                />
              </CFLink>
            </CFView> */}
            <OrderDeliveryButton />
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
